import { render } from "./OrgAllTrainees.vue?vue&type=template&id=1b9b8e04&scoped=true"
import script from "./OrgAllTrainees.vue?vue&type=script&lang=js"
export * from "./OrgAllTrainees.vue?vue&type=script&lang=js"

import "./OrgAllTrainees.vue?vue&type=style&index=0&id=1b9b8e04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b9b8e04"]])

export default __exports__